module.exports = __webpack_public_path__ + "static/img/product06.060b78d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product06.png
// module id = oItH
// module chunks = 1